var map = {
	"./campuslabs/index": 206,
	"./giving/index": 648,
	"./news/index": 602,
	"./people/index": 131
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return Promise.all(/* lazy-once context | wsu_embeds_components */[__webpack_require__.e(107), __webpack_require__.e(171)]).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 413;
module.exports = webpackAsyncContext;